import { logo } from "@/constants";
import { Link } from "react-router-dom";

const Footer = () => {
    return (
        <div className="pb-16 pt-4 flex flex-col justify-center items-center text-sm font-light text-gray-400 bg-white">
            <div className="flex justify-center items-center">
                <p>powered by</p>
                <img className="w-16 pl-2" src={`../../${logo}`} alt="foodb" />
            </div>
            <nav className="flex gap-3 justify-center items-center flex-col sm:flex-row">
                <Link className="hover:text-primary" to={"/policy/terms"}>
                    Terms & Conditions
                </Link>
                <Link className="hover:text-primary" to={"/policy/privacy"}>
                    Privacy Policy
                </Link>
                {/* <Link className="hover:text-primary" to={"/policy/refund"}>
                    Refund Policy
                </Link> */}
                <Link className="hover:text-primary" to={"/policy/cookie"}>
                    Cookie Policy
                </Link>
            </nav>
        </div>
    );
};
export default Footer;
